import {getAgencyMattersList} from "@/api/toDoReminder";
import {TYPES, TYPE_FIELD, RECORD_FIELD} from '@/constants/toDoReminder'

export default {
    namespaced: true,
    state: {
        list: [],
    },
    actions: {
        async loadToDoReminderList(context) {
            let list = []
            // 获取展会相关
            try {
                let {resp} = await getAgencyMattersList()
                list.push(...resp.map(item => {
                    return {
                        [TYPE_FIELD]: TYPES.Markets,
                        [RECORD_FIELD]: item
                    }
                }))
            } catch (e) {
                console.error(e)
            }
            // 获取订单相关
            // 获取竞品相关
            // 获取其他相关
            context.commit('setToDoReminderList', list)
        }
    },
    mutations: {
        setToDoReminderList(state, list) {
            state.list = list
        }
    }
}
